<template>
  <component :is="showPage" />
</template>

<script>
import {
  defineComponent,
  onMounted,
  ref,
  computed,
} from "@vue/composition-api";

import { useStore } from "@/components/use/base";

import CommonVisitor from "./page/CommonVisitor.vue";
import WxjkVisitor from "./page/WxjkVisitor.vue";
import HuanbeiVisitor from "./page/HuanbeiVisitor.vue";
import NewVisitor from "./page/NewVisitor.vue";

export default defineComponent({
  components: {
    CommonVisitor,
    WxjkVisitor,
    HuanbeiVisitor,
    NewVisitor,
  },

  setup() {
    const pageType = ref("");
    const store = useStore();

    const showPage = computed(() => {
      return pageType.value;
    });

    const namespaceGroup = computed(
      () => store.state.namespaceInfo.namespace_group_en
    );

    onMounted(() => {
      pageType.value =
        {
          weixinjinke: "WxjkVisitor",
          huanbei: "HuanbeiVisitor",
          "58sk": "NewVisitor",
          bajiexiaoka: "NewVisitor",
        }[namespaceGroup.value] || "CommonVisitor";
    });

    return {
      showPage,
    };
  },
});
</script>

<style lang="less" scoped>
</style>